"use client";

import Image from "next/image";
import { m } from "framer-motion";
import Banner from "../Banner/Banner";
import FadeIn from "../FadeIn/FadeIn";
import styles from "../../../styles/home/banner/homeslider.module.css";

const slide = {
  image: "/home-page/banner/banner-image.webp",
  mobileImage: "/home-page/banner/banner-mobile.jpg",
};

export default function HomeSlider() {
  return (
    <div className={styles.bannerContainer}>
      <div className={styles.heroBackground}>
        <div className={styles.desktopImage}>
          <Image 
            src={slide.image}
            alt="Home Page Background Desktop" 
            fill 
            sizes="100vw"
            quality={60}
            className={styles.heroImage} 
            priority
            fetchPriority="high"
          />
        </div>
        <div className={styles.mobileImage}>
          <Image 
            src={slide.mobileImage}
            alt="Home Page Background Mobile" 
            fill 
            sizes="(max-width: 768px) 100vw, 0vw"
            quality={60}
            className={styles.heroImage} 
            priority
            fetchPriority="high"
          />
        </div>
      </div>
      
      <div className={styles.contentOverlay}>
        <FadeIn fullWidth direction="none">
          <Banner />
        </FadeIn>
      </div>
    </div>
  );
}
